<template>
    <div id="todo-body" ref="todoElement">
        <CCBlockFrame :header="{ title: title1, icon: appletData.icon, more: true, code: 'mytbsk.svg' }">
            <div v-if="todolist">
                <div v-if="todolist.length > 0">
                    <div v-for="(item, index) in todolist" :key="index" class="link-message" @click="openWorkFlow(item)">
                        <div class="item" :style="{fontWeight:item.openTime==null?'bolder':'normal'}">
                            <div class="title" style="display: flex">
                                <!-- <div v-if="item.extField3" style="width: 96%;color: rgb(155, 155, 155);overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ item.title }}</div> -->
                                <div style="width: 96%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">{{ item.title }}</div>
                            </div>
                            <div class="bottom">
                                <span class="name">{{ item.senderName }}&nbsp;&nbsp;&nbsp;&nbsp;{{ item.createTime }}</span>
                                <span class="time">{{ item.wfName }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else style="text-align: center; padding-top: 30px">
                    <img src="images/w-imgs/nomessage.png" style="max-width: 180px" />
                    <br />
                    <span v-text-lbl="'common.noData'" style="font-size: var(--portalFontSize15); color: #dbdbdb">暂无数据</span>
                </div>
            </div>
        </CCBlockFrame>
    </div>
</template>

<script>
export default {
    name: 'Todo',
    components: {},
    props: {
        title: { type: String, default: '待办待阅' },
        appletData: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            showTable: true,
            todolist: [],
            windowWidth: document.body.clientWidth, // 浏览器窗口宽度
            contentWidth: '',
            checktype: '',
            show: false,
            toDoAccount: 0, // 待办事项
            toReadAccount: 0, // 待阅事项
            moduleInfo: {
                queryNoticeDataUrl: 'usersetting/noticeSetup/querydata' // 查询办文提醒是否存在数据
            },
            state: [],
            title1: [
                // { name: '待办事项', code: 'myTodo', click: this.tabClick, count: this.toDoAccount },
                // { name: '待阅事项', code: 'myToRead', click: this.tabClick, count: this.toReadAccount }

                { name: this.$tx('ecoa.portal.todoItem', '待办事项'), code: 'myTodo', click: this.tabClick, count: this.toDoAccount },
                { name: this.$tx('ecoa.portal.toReadItem', '待阅事项'), code: 'myToRead', click: this.tabClick, count: this.toReadAccount }
            ],
            isShow: false
        }
    },
    computed: {
        curUser() {
            return this.$store.getters.loginUser
        }
    },
    created() {
        this.getState()
        this.$bus.on('appletTabsClick', this.tabClick)
        this.$bus.on('refreshTableData', this.refreshTableData)
    },
    beforeDestroy() {
        this.$bus.off('appletTabsClick', this.tabClick)
        this.$bus.off('refreshTableData', this.refreshTableData)
        window.removeEventListener('resize', this.onresize, false)
    },
    mounted() {
        const _this = this
        // 监听浏览器窗口变化
        window.addEventListener('resize', this.onresize, false)
        // window.addEventListener('message', this.refreshTableData)
    },
    methods: {
        // 获取待阅和待办事项的数量
        async getInfo() {
            // 是否开启伪数据
            if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                const defaultData = await this.$getDefaultData(this, this.appletData.id)
                const list = defaultData.wfItemMap
                const obj = list
                this.toReadAccount = obj.toReadCount ? obj.toReadCount : 0
                this.toDoAccount = obj.todoCount ? obj.todoCount : 0
                if (this.state.indexOf('myTodo') !== -1) {
                    this.title1[0].count = this.toDoAccount
                }
                if (this.state.indexOf('myToRead') !== -1) {
                    this.title1[1].count = this.toReadAccount
                }
                this.show = true
                return
            }
            this.$http({
                contentType: 'application/x-www-form-urlencoded',
                url: '/workflow/wfTaskItem/findWfTaskItemCount',
                method: 'GET',
                params: {
                    sysCode: this.$route.meta.sysCode,
                    timeoutCount: true
                }
            }).then((res) => {
                if (res.code === 'success') {
                    const obj = res.body.wfItemMap
                    this.toReadAccount = obj.toReadCount ? obj.toReadCount : 0
                    this.toDoAccount = obj.todoCount ? obj.todoCount : 0
                    if (this.state.indexOf('myTodo') !== -1) {
                        this.title1[0].count = this.toDoAccount
                    }
                    if (this.state.indexOf('myToRead') !== -1) {
                        this.title1[1].count = this.toReadAccount
                    }
                    this.show = true
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 获取状态是否显示
        getState() {
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                data: [
                    {
                        compare: '=',
                        field: 'sysCode',
                        merge: false,
                        value: this.curUser.sysCode
                    },
                    {
                        compare: '=',
                        field: 'ownerAccount',
                        merge: false,
                        value: this.curUser.personAccount
                    }
                ],
                url: this.moduleInfo.queryNoticeDataUrl
            }).then((response) => {
                if (response.body.listdata && response.body.listdata.length > 0) {
                    this.state = response.body.listdata[0].todoCountHint
                    this.getInfo()
                } else {
                    this.getInfo()
                }
            })
        },
        // 查询待办待阅事项
        async getTodo(type) {
            // this.isShow = false
            this.checktype = type
            // 获取dom元素宽度
            this.$nextTick(function () {
                if (this.$refs.todoElement) {
                    this.contentWidth = this.$refs.todoElement.offsetWidth
                }
            })

            let listpage = ''
            if (type === 'myTodo') {
                listpage = 'workflow.wfTaskItem.myTodo'
                // 是否开启伪数据
                if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                    const defaultData = await this.$getDefaultData(this, this.appletData.id)
                    const list = defaultData.grmhDbData
                    this.todolist = list.splice(0, 5)
                    // this.nullProcessing('value', this.appletData.icon, this.position)
                    return
                }
            } else if (type === 'myToRead') {
                listpage = 'workflow.wfTaskItem.myToread'
                // 是否开启伪数据
                if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                    const defaultData = await this.$getDefaultData(this, this.appletData.id)
                    const list = defaultData.grmhDyData
                    this.todolist = list.splice(0, 5)
                    // this.nullProcessing('value', this.appletData.icon, this.position)
                    return
                }
            }
            this.$http({
                url: 'workflow/wfTaskItem/listdata',
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    listpageViewUrl: listpage,
                    pageNum: 1,
                    // pageSize: this.appletData.loadDataCount,
                    pageSize: 5,
                    order: 'asc'
                }
            }).then((res) => {
                if (res.code === 'success') {
                    const list = res.body.pageInfo.list
                    // const length = 6 - JSON.parse(JSON.stringify(res.body.pageInfo.list))
                    // for (let i = 0; i < length; i++) {
                    //     list.push({})
                    // }
                    const length = list.length
                    if (list.length < 5 && list.length > 0) {
                        for (let i = 0; i < 5 - length; i++) {
                            list.push({})
                        }
                    }
                    this.todolist = list
                    // this.isShow = true
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        columnFormatter(row, column, cellValue, index) {
            if (cellValue) {
                return cellValue.substr(0, 16)
            } else {
                return
            }
        },
        openWorkFlow(row, column, cell, event) {
            if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                this.$bus.emit('openDefaultDialog', this.appletData.name)
                return
            }
            // if (row.itemUrl && row.itemUrl.indexOf('/wflow') !== 0 && row.module) {
            //     row.itemUrl = '/wflow/busiform/' + row.module + row.itemUrl
            // }
            if (row.id) {
                var openPage = window.open('/#' + row.itemUrl)
                const that = this
                openPage.addEventListener('unload', function () {
                    // 在页面B关闭时执行的代码
                    // 可以在此处触发页面A的相应操作
                    //  that.$bus.emit('refreshListData')
                    that.getTodo(that.checktype)
                    that.getState()
                    that.$bus.emit('shuaxing', true)
                })
            }
        },
        tabClick(data) {
            this.getTodo(data.code)
        },
        onresize() {
            this.contentWidth = this.$refs.todoElement.offsetWidth
        },
        refreshTableData() {
            this.getState()
            this.getTodo(this.checktype)
        }
    }
}
</script>

<style scoped lang="scss">
#todo-body {
    // background-color: #fff;
    // width:100%;
    height: 100%;
}
//     border-radius:3px;
//     /deep/ .tablelist{
//         // padding: 0 5px 0 0;
//         border-radius:0 0 3px 3px;
//         .el-table__body{cursor: pointer;}
//     }
//  }
//  /deep/ .has-gutter tr th{
//     background-color: #fff !important;
//  }
//表格隐藏表头 删除行列线条
// .hideline{
//   height: 100%;
//   /deep/.el-table__row>td{
//     border: none;
//   }
//   /* 去掉上面的线 */
//   /deep/.el-table th.is-leaf{
//     border: none;
//   }
//   /* 去掉最下面的那一条线 */
//   /deep/.el-table::before {
//     height: 0px;
//     width: 0;
//   }
// }
// /deep/.hideline .el-table__row>td{
//           border-bottom: 1px solid #EBEEF5 !important;
//         }
/deep/ .has-gutter tr th {
    background-color: #fff !important;
}
/deep/ .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
    padding: 10px 15px;
    width: 100%;
    height: 100%;
    border-bottom: 1px dashed #eff4fc;
    cursor: pointer;
}
/deep/.el-table .el-table__header-wrapper .el-table__header thead th {
    border-bottom-color: #fff;
}

.link-message {
    list-style: none;
    .item {
        padding: 10px 15px;
        width: 100%;
        height: 100%;
        border-bottom: 1px dashed #eff4fc;
        cursor: pointer;
    }
    .title {
        font-size: var(--portalFontSize14);
        color: #333333;
        height: 25px;
        line-height: 25px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .bottom {
        font-size: var(--portalFontSize13);
        color: #9b9b9b;
        height: 25px;
        line-height: 25px;
        font-family: MicrosoftYaHei;
        display: flex;
        justify-content: space-between;
        .name {
            display: inline-block;
            font-size: var(--portalFontSize13);
            font-family: MicrosoftYaHei;
            color: #999;
        }
        .time {
            display: block;
            display: inline-block;
            font-size: var(--portalFontSize13);
            font-family: MicrosoftYaHei;
            color: #ec8423;
            text-align: right;
        }
    }
}
.link-message:last-child .item {
    border-bottom: none;
}
.link-message:hover {
    background: #f5f7fa;
}
</style>
